
class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabTriggers = this.querySelectorAll('ul.tabs_benefits li');
    this.tabContents = this.querySelectorAll('.tabs_container .tab_content');

    this.tabTriggers.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }

  switchTab(selectedTab) {
    if (selectedTab.classList.contains('active')) return;

    const tabId = selectedTab.id;

    this.tabTriggers.forEach(t => t.classList.remove('active'));
    this.tabContents.forEach(c => c.classList.remove('active'));

    selectedTab.classList.add('active');

    const targetContent = this.querySelector(`.tab_content[data-tab="${tabId}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }
}
if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}

